export default __webpack_public_path__ + "static/media/gift-small-arrow.ffd34642.svg";